import SelectCustom, { type SelectOption } from '../../../../components/SelectCustom'
import { CustomerAuthInputField } from './CustomerAuthInputField'
import type { CustomerAuthFieldUiHelpers } from './types'

type SignupPersonalStepProps = {
  personalDataSectionLabel: string
  firstNameLabel: string
  firstNamePlaceholder: string
  lastNameLabel: string
  lastNamePlaceholder: string
  taxCodeLabel: string
  taxCodePlaceholder: string
  genderLabel: string
  genderPlaceholder: string
  genderOptions: SelectOption[]
  emailLabel: string
  emailPlaceholder: string
  firstName: string
  lastName: string
  taxCode: string
  gender: string
  email: string
  onFirstNameChange: (value: string) => void
  onLastNameChange: (value: string) => void
  onTaxCodeChange: (value: string) => void
  onGenderChange: (value: string) => void
  onEmailChange: (value: string) => void
  ui: CustomerAuthFieldUiHelpers
}

export const SignupPersonalStep = ({
  personalDataSectionLabel,
  firstNameLabel,
  firstNamePlaceholder,
  lastNameLabel,
  lastNamePlaceholder,
  taxCodeLabel,
  taxCodePlaceholder,
  genderLabel,
  genderPlaceholder,
  genderOptions,
  emailLabel,
  emailPlaceholder,
  firstName,
  lastName,
  taxCode,
  gender,
  email,
  onFirstNameChange,
  onLastNameChange,
  onTaxCodeChange,
  onGenderChange,
  onEmailChange,
  ui,
}: SignupPersonalStepProps) => (
  <section className="space-y-2.5">
    <h2 className="sr-only">{personalDataSectionLabel}</h2>
    <div className="grid gap-2.5 md:grid-cols-2">
      <CustomerAuthInputField
        field="firstName"
        label={firstNameLabel}
        value={firstName}
        onChange={onFirstNameChange}
        placeholder={firstNamePlaceholder}
        required
        ui={ui}
      />
      <CustomerAuthInputField
        field="lastName"
        label={lastNameLabel}
        value={lastName}
        onChange={onLastNameChange}
        placeholder={lastNamePlaceholder}
        required
        ui={ui}
      />
    </div>

    <div className="grid gap-2.5 md:grid-cols-2">
      <CustomerAuthInputField
        field="taxCode"
        label={taxCodeLabel}
        value={taxCode}
        onChange={onTaxCodeChange}
        normalizeValue={(value) => value.toUpperCase()}
        placeholder={taxCodePlaceholder}
        autoCapitalize="characters"
        required
        extraClassName="uppercase"
        ui={ui}
      />
      <label className="grid min-w-0 gap-1 text-sm font-medium text-(--color-text-secondary)">
        <span>
          {genderLabel}
          {ui.fieldLabelRequiredMark}
        </span>
        <SelectCustom
          value={gender}
          onChange={onGenderChange}
          onBlur={() => ui.onFieldBlur('gender')}
          ariaLabel={genderPlaceholder}
          ariaInvalid={Boolean(ui.resolveFieldError('gender'))}
          describedById={ui.resolveErrorDescribedBy('gender')}
          placeholder={genderPlaceholder}
          options={genderOptions}
          buttonClassName={ui.resolveSelectClassName('gender')}
        />
        {ui.renderFieldHint('gender')}
      </label>
    </div>

    <CustomerAuthInputField
      field="email"
      label={emailLabel}
      type="email"
      value={email}
      onChange={onEmailChange}
      placeholder={emailPlaceholder}
      autoComplete="email"
      required
      ui={ui}
    />
  </section>
)
